/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { Box, EmptyState, EmptyStateListWhite, Flex } from "@eworkit/iris";
import { FC, useContext } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { jsx } from "theme-ui";

import { LoadingSpinner } from "@/components/Loading";
import { UserContext } from "@/components/User";
import { fetchContract } from "@/data/contracts";
import { withRouteProps } from "@/infrastructure/Route";

import { ContractDetailsHeader } from "./ContractDetailsHeader";
import { ContractDetailsTabPanels } from "./ContractDetailsPanels";
import { ContractDetailsRouteProps, transformRouteProps } from "./selectors";

export const ContractDetailsViewComponent: FC<ContractDetailsRouteProps> = ({ routeProps }) => {
  const { t } = useTranslation("session");
  const { contextCompany } = useContext(UserContext);

  const { data, isLoading, isError } = useQuery(["contract", routeProps.contractId], () =>
    fetchContract({ contractId: routeProps.contractId, companyId: contextCompany?.id }),
  );

  return (
    <Flex flexDirection="column">
      {isLoading && (
        <Flex my="xxl" justifyContent="center" alignItems="center">
          <LoadingSpinner size="lg" variant="primary" />
        </Flex>
      )}
      {!isLoading && !isError && data && (
        <>
          <ContractDetailsHeader contract={data} />
          <ContractDetailsTabPanels contract={data} />
        </>
      )}
      {isError && (
        <Box sx={{ py: 120 }} px="sm">
          <EmptyState
            icon={<EmptyStateListWhite />}
            title={t("CONTRACTS.NO_MATCHING_CONTRACTS")}
            content={t("CONTRACTS.NO_MATCHING_CONTRACTS_DESCRIPTION")}
          />
        </Box>
      )}
    </Flex>
  );
};

export const ContractDetailsView = withRouteProps(ContractDetailsViewComponent, transformRouteProps);
